module.exports = __webpack_public_path__ + "img/p.2727db84.png";